import React, {forwardRef} from 'react';
import store from 'javascripts/store';
import t from 'javascripts/utils/translation';
import {observer} from 'mobx-react';

const EmailField = observer(forwardRef((props, ref) => {
  if(store.donateForm.isUserLoggedIn) return null;

  return (
    <div className='input-wrapper mt-2'>
      <input
        className='lh rounded border-grey-40'
        data-email
        data-parsley-email-tld=''
        data-parsley-error-message={t('views.donate_form.email_error')}
        id={`${store.donateForm.campaignSlug}_donation_form_email`}
        name='email'
        onChange={e => store.donateForm.email = e.target.value}
        placeholder={t('views.donate_form.email_placeholder')}
        ref={ref}
        required='required'
        type='email'
        value={store.donateForm.email}
      />
    </div>
  );
}));

export default EmailField;
